// react
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
// store
import { authService } from "../../store/services/ServiceAuth";
import { routes } from "../../store/routes";
// components
import ResetPasswordForm from "./ResetPasswordForm";
// others
import { GAPageView, initGA } from "../../index";
import Navbar from "../../components/general/Navbar";

// component
function ResetPassword() {
    let history = useHistory();
    let dispatch = useDispatch();

    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    useEffect(() => {
        async function checkUser() {
            let result = await authService.getAccessToken();
            if (result !== false) {
                history.push(routes.DASHBOARD);
            }
        }

        checkUser();
    }, [history, dispatch]);

    // template
    return (
        <>
            <Navbar linkBack="/login" />
            <div style={{
                minHeight: 'calc(100vh - 80px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--body-bg)',
                padding: '1rem'
            }}>
                <ResetPasswordForm userEmail={""} />
            </div>
        </>
    );
}

export default ResetPassword;
